import React, { ReactNode } from 'react';
import { TypeOptions, toast } from 'react-toastify';

import TextWithIcon from '../../molecules/TextWithIcon';
import { IIdentifierObject } from '../../types';

const mapNotification = (notification: ReactNode): ReactNode => {
  switch (notification) {
    case 'subscription_successful':
      return 'You have successfully subscribed to NordLayer';
    case 'payment_failed':
      return 'Payment failed. Try again or contact the sales team.';
    case 'subscription_renew_successful':
      return 'Your subscription was renewed successfully';
    case 'top_up_successful':
      return 'Your purchase was successful';
    case 'subscription_canceled_successfully':
      return 'Your subscription was cancelled successfully';
    case 'subscription_expired':
      return 'Your subscription has expired. To renew it, purchase a subscription plan again.';
    case 'subscription_upgrade_successful':
      return 'Your subscription was upgraded successfully';
    default:
      return notification;
  }
};

export interface INotificationProps {
  type: TypeOptions;
  reason: ReactNode;
}

export interface INotification extends INotificationProps, IIdentifierObject {}

const Component: React.FC<INotificationProps> = ({ type, reason }) => (
  <TextWithIcon
    data-testid="notification"
    icon={`images/global/icons/16/${type === toast.TYPE.WARNING ? toast.TYPE.INFO : type}.svg`}
    iconTitle={type.toUpperCase()}
    variant="caption"
    className="font-medium justify-center"
    componentClassName="mr-3"
  >
    {mapNotification(reason)}
  </TextWithIcon>
);

export default Component;
